<template>
    <div class="content">
      <router-view @refresh="refresh()"></router-view>
      <header class="content-header">
          <div class="wrapper">

              <div>
                  <h1>Campagnes</h1>
                  <p>Gestion des campagnes</p>

                <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
              </div>

            <actions-dropdown>
              <li v-if="$aclInterfaceValidator('weeboxcore.campaign.create')" class="main" @click="createCampaign('email')">
                <icon name="file-plus-02"/>
                <span>Créer une campagne E-mail</span>
              </li>
              <li v-if="$aclInterfaceValidator('weeboxcore.campaign.create')" class="main" @click="createCampaign('sms')">
                <icon name="file-plus-02"/>
                <span>Créer une campagne SMS</span>
              </li>
              <li v-if="$aclInterfaceValidator('weeboxcore.campaign.export')" @click="exportFile('invoices')">
                <icon name="download-cloud-01"/>
                <span>Export les résultats (Excel)</span>
              </li>
            </actions-dropdown>

          </div>
      </header>

      <filters v-model="filters" :paginator="paginator" :tabs="tabsFilter" active-advanced-filter="false" active-tabs="false" @refresh="refresh()" @setFilter="setFilter"></filters>

      <div class="content-body">

                    <section>
                        <div class="campaigns" v-if="resources && resources.length">
                            <div class="datagrid" :class="paginator.listing">
                                <div class="datagrid-header">
                                    <div>
                                        <div></div>
                                        <div></div>
                                        <div>
                                          <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                                        </div>
                                        <div class="center"><i class="icon icon-icon_users"></i></div>
                                        <div class="center" v-if="paginator.filter=='sent'"><span>Coûts</span></div><!--
                                        <div class="center"><i class="icon icon-icon_passbook"></i></div>
                                        <div class="center">Wallet Pass</div>-->
                                        <div class="center" v-bind:class="[ paginator.sort == 'type' ? 'active' : '', paginator.order ]">
                                          <datagrid-sort :data="[{name:'Type', value:'type'}]" v-model="paginator"></datagrid-sort>
                                        </div>
                                        <div class="center" v-if="paginator.filter=='sent'">
                                           <span>% Envoyés</span>
                                        </div>
                                        <div class="center">
                                          <span>Statut</span>
                                        </div>
                                        <div class="center" v-if="paginator.filter!='sent'">
                                          <datagrid-sort :data="[{name:'Planification', value:'tmp_next_run_date'}]" v-model="paginator"></datagrid-sort>
                                        </div>
                                        <div class="center" v-if="paginator.filter=='sent'">
                                          <datagrid-sort :data="[{name:'Envoyé le', value:'lastdate'}]" v-model="paginator"></datagrid-sort>
                                        </div>
                                        <div class="center"><span>Scopes</span></div>
                                        <div class="actions"></div>
                                        <div></div>
                                    </div>
                                </div>
                                <div class="datagrid-body">
                                    <div v-for="item in resources" @dblclick="editCampaign(item)">
                                        <div></div>
                                        <div class="picture">
                                            <figure v-bind:class="{'draft':item.publication_state_id>1}">
                                                <i v-if="!item.picture && item.support == 'email'" class="icon icon-icon_email"></i>
                                                <i v-if="!item.picture && item.support == 'sms'" class="icon icon-icon_sms"></i>
                                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                                            </figure>
                                        </div>
                                        <div data-field="name"><strong class="highlight">{{ item.name }}</strong><p>{{ item.description }}</p><p>{{ item.slug }}</p></div>
                                        <div class="center">{{ paginator.filter=='sent' ? item.total_sent : item.audience }}</div>
                                        <div class="center" v-if="paginator.filter=='sent'">
                                            CHF {{ item.total_cost|formatNumber }}
                                        </div>
                                        <div data-field="type" class="center">
                                            <i v-if="item.support == 'sms'" class="icon icon-icon_sms" style="font-size:20px;"></i>
                                            <i v-if="item.support == 'email'" class="icon icon-icon_email" style="font-size:20px;"></i>
                                            <!--<active v-model="item.is_template_blade"></active>-->
                                        </div>
                                        <div class="center" v-if="paginator.filter=='sent'">
                                            <CampaignProgressWidget :id="item.campaign_publication_id" v-if="item.campaign_publication_id"></CampaignProgressWidget>
                                        </div>
                                        <div class="center"><published v-model="item.published" :date-start="item.start_at" :date-end="item.end_at"></published></div>
                                        <div class="center">
                                            <datetime v-model="item.lastdate" :human="true" v-if="paginator.filter=='sent'"></datetime>
                                            <datetime v-model="item.tmp_next_run_date" :human="true" v-if="paginator.filter!='sent'"></datetime>
                                        </div>
                                        <div data-field="scope" class="center"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                                        <div class="actions">
                                            <ul>
                                                <li v-if="item.policies && item.policies.delete && paginator.filter != 'sent'"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                                <li v-if="item.policies && item.policies.update">
                                                    <button @click="editCampaign(item)">
                                                        <i class="icon icon-icon_pencil" v-if="paginator.filter != 'sent'"></i>
                                                        <i class="icon icon-icon_search" v-if="paginator.filter == 'sent'"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="empty-actions" v-if="resources && resources.length == 0">
                          <!--
                            <div @click="createCampaign('email')">
                                <i class="icon icon-icon_email"></i>
                                <h3>Créer une campagne Email</h3>
                                <p>Envoyer des emails à vos contacts, en direct ou en différé.</p>
                                <button><span>Créer</span></button>
                            </div>
                            -->

                            <div @click="createCampaign('sms')">
                                <i class="icon icon-icon_sms"></i>
                                <h3>Créer une campagne SMS</h3>
                                <p>Envoyer des SMS à vos contacts, en direct ou en différé.</p>
                                <button><span>Créer</span></button>
                            </div>
                        </div>

                    </section>

                    <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

                </div>
    </div>
</template>
<script>
    import CampaignService from './CampaignService.js';
    import Index from '../../../layouts/Index.vue';
    import CampaignProgressWidget from './CampaignProgressWidget.vue'

    export default {
        extends: Index,
        components: {
            'CampaignProgressWidget': CampaignProgressWidget
        },
        data () {
            return {
              tabsFilter: [
                {
                  slug: '',
                  name: 'Tout'
                },
                {
                  slug: 'draft',
                  name: 'Brouillons'
                },
                {
                  slug: 'planned',
                  name: 'Planifié'
                },
                {
                  slug: 'sent',
                  name: 'Envoyés'
                }
              ]
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return CampaignService;
            },
            createCampaign: function(support){
                this.create({support: support})
            },
            editCampaign: function(item){
                if( this.paginator.filter == 'sent' ){
                    this.$router.push({ name: this.$route.name + '-publication', params: {id: item.campaign_publication_id}});
                }else{
                    this.edit(item.id);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/campaign/campaign/Index.vue